export default __webpack_public_path__ + "static/media/women.401e7e14.jpg";